'use client'

import { useRef, useState, type ReactNode } from 'react'

import dynamic from 'next/dynamic'

import { Anchor } from '@/components/client/seo/anchor'

const Gallery = dynamic(() => import('@/components/client/shared/gallery').then((module) => module.Gallery), {
  ssr: false,
})

type Props = {
  videoId: string
  title: string
  label: string
  className: string
  children: ReactNode
}

/** Keeps the poster server-rendered and loads the site's player only when opened. */
export const VideoLink = ({ videoId, title, label, className, children }: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const trigger = useRef<HTMLAnchorElement>(null)

  return (
    <>
      <Anchor
        ref={trigger}
        data-tracking="ignore"
        data-video-id={videoId}
        href={`https://www.youtube.com/watch?v=${videoId}`}
        aria-label={label}
        className={className}
        onClick={(event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return
          }
          event.preventDefault()
          setIsOpen(true)
        }}
      >
        {children}
      </Anchor>
      {isOpen && (
        <Gallery
          media={[{ type: 'youtube', videoId, title }]}
          isOpen
          onClose={() => {
            setIsOpen(false)
            requestAnimationFrame(() => trigger.current?.focus())
          }}
        />
      )}
    </>
  )
}
